import { formatAppDateTime } from "../../utils/appTime";

export const NOTIFICATION_REFRESH_EVENT = "tms:notifications-refresh";

export const NOTIFICATION_SCOPE_OPTIONS = [
    { value: "ALL", label: "All" },
    { value: "UNREAD", label: "Unread" },
    { value: "TASK", label: "Task" },
    { value: "INVENTORY", label: "Inventory" },
    { value: "MCO", label: "MCO" },
    { value: "CRITICAL", label: "Critical" },
];

export const formatNotificationDate = (value) =>
    formatAppDateTime(value, "YYYY-MM-DD hh:mm A");

export const getNotificationSeverityColor = (severity) => {
    if (severity === "critical") return "error";
    if (severity === "warning") return "warning";
    return "info";
};

export const getNotificationPath = (notification) => {
    if (!notification) {
        return "/dashboard";
    }

    if (notification.entityType === "TASK" && notification.entityId) {
        return `/task/${notification.entityId}`;
    }

    switch (notification.type) {
        case "MCO_PENDING_ASSIGNMENT_AGING":
            return "/mco/pending-assignments";
        case "MCO_SITREK_PENDING_ASSIGNMENT_MISSING":
            return "/mco/mismatches";
        case "PART_CHANGE_APPROVAL_REQUEST":
            return "/change-approvals";
        case "PART_CHANGE_APPROVAL_RESPONSE":
        case "PARTS_ASSIGNED":
            return "/my-parts";
        case "PART_SENT_TO_OFFICE":
        case "OFFICE_REPAIR_PENDING_ALERT":
        case "WARRANTY_PENDING_ALERT":
            return "/repair-warranty";
        case "LOW_STOCK_ALERT":
            return "/inventory";
        default:
            return "/notifications";
    }
};
